import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';

import AssetItem from '../../../../../../src/components/asset/asset-item';
import {
  AssetItemHeaderDescription,
} from '../../../../../../src/components/asset/asset-item/asset-item-header';

// import Text from '../../../../../../src/components/common/text';
import Text from '@dbk/ui-text';
import TableRow from '../../../../../../src/components/common/table-row';
import SimpleDate from '../../../../../../src/components/common/date';
import { Currency, ChangeIndicatedAbbreviatedNumber } from '../../../../../../src/components/common/number';
import { Large } from '../../../../../../src/components/common/text';

import styles from '../../../../../../src/screens/maturities-assets/transaction/transaction.styles';
import get from 'lodash/get';
import { NO_DATA } from '../../../../../../src/constants';
import labelForPFid from '../../../../../../src/utils/portfolio-number-aria-label';
import { PALETTE } from '../../../constants';

const LEFT_ALIGNED_KEYS = [
  'maturityPandIPosCcyUnit',
  'maturityPFID',
  'isin',
];

class Transaction extends PureComponent {
  renderColumnValue(row, option) {
    const value = row[option.key];

    if (value == null) {
      return (
        <div aria-label={this.props.messages['app.common.nullValue']}>
          <Text>{NO_DATA}</Text>
        </div>
        )
    }

    if (option.type === 'date') {
      return (
        <SimpleDate
          value={value}
          renderProps={{ size: 'normal' ,type: 'primary'}}
        />
      );
    }

    if (option.type === 'currency') {
      return (
        <ChangeIndicatedAbbreviatedNumber
          value={value}
          // maxDigits={8}
          renderExactAs="currency"
          onlyNegativeStyling
          renderProps={{ size: 'small' ,color: PALETTE.secondaryActive}}
        />
      );
    }

    if (option.key==="maturityPFID") {
      return (
        <div aria-label={labelForPFid(value)}>
          <Text>{value}</Text>
        </div>
        )
    }
    if (option.key === "maturityPandIPosCcyUnit") {
      return (
        <div className="padding-left-25">
          <Text>{value}</Text>
        </div>
      )
    }
    if (option.key==="maturityPandIPosCcy"){
      return (
        <div aria-label={value<0 ? (this.props.messages['app.common.minusSign']+ value) : value}>
          <Text className="padding-right-15">{value}</Text>
        </div>
        )
    }

    return <Text>{value}</Text>;
  }

  renderColumn(row, option, screen) {
    let columnProps;
    if(!screen.isSmall){
      if(row.assetId == 'optionsDerivatives'){
         columnProps =  option.key !==  'name' ?
        { align: 'left' } : {align: 'right'};
      } else {
        if (LEFT_ALIGNED_KEYS.includes(option.key)) {
          columnProps = { align: 'left' };
        } else {
          columnProps = option.key !== 'maturityDate'?
          { align: 'right' } : {align: 'left'};
        }
      }
    } else {
      if (LEFT_ALIGNED_KEYS.includes(option.key)) {
        columnProps = { align: 'left' };
      } else {
        columnProps = option.key !== 'maturityDate' ?
        { align: 'right' } : {align: 'left'};
      }
    }

    return (
      <TableRow.Column key={option.key} {...columnProps} width={option.rowWidth} gutter={false}>
        {this.renderColumnValue(row, option)}
      </TableRow.Column>
    );
  }

  render() {
    const {
      row,
      options,
      descriptionMaxChars,
      deviceInfo,
      screen,
      messages
    } = this.props;

    return (
      <AssetItem>
        {
          (!(!screen.isSmall && row.assetId == 'optionsDerivatives')) &&
          <TableRow style={styles.topRow}>
            <TableRow.Column
              align="left"
              testID="description">
              <AssetItemHeaderDescription
                row={{description: row.name}}
                shorten={descriptionMaxChars}
              />
            </TableRow.Column>
          </TableRow>
        }
        <TableRow style={styles.bottomRow}>
          {options.map(opt => this.renderColumn(row, opt, screen))}
        </TableRow>
      </AssetItem>
    );
  }
}

Transaction.propTypes = {
  row: PropTypes.shape({
    name: PropTypes.string,
    maturityDate: PropTypes.string,
    maturityValue: PropTypes.number,
    maturityPFID: PropTypes.number,
    maturityPandIPosCcyUnit: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    width: PropTypes.number,
    type: PropTypes.string,
  })),
  descriptionMaxChars: PropTypes.number,
  deviceInfo: PropTypes.object,
  screen: PropTypes.object,
};

export default createContainer({
  $fragments: {
    uiStatic: {
      options: true,
    },
  },
}, ({ uiStatic }) => ({
  options: uiStatic.options,
}))(Transaction);
